export default __webpack_public_path__ + "static/footer-soc-c4abbb04bd46089482a0364665673df2.webp";